import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import PieChart from '../../../components/PieChart/PieChart';
import NoData from '../../../components/NoData/NoData';
import { DISTINCT_PIE_SLICE_COLORS } from '../../../shared/distinctPieSliceColors';

type Props = { timeRange: { start: string; end: string } };

function BookingsTypeDistribution({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);
  const [sliceColors, setSliceColors] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getBookingsTypeDistribution({ startTime: timeRange.start, endTime: timeRange.end });
        const rawLabels = res.data?.labels || [];
        const apiValues = (res.data?.values || []).map((v) => Number(v));
        const colors = rawLabels.map((_: string, i: number) => DISTINCT_PIE_SLICE_COLORS[i % DISTINCT_PIE_SLICE_COLORS.length]);
        setLabels(rawLabels);
        setValues(apiValues);
        setSliceColors(colors);
      } catch (e) {
        setLabels([]);
        setValues([]);
        setSliceColors([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end, t]);

  if (!labels.length) return <NoData message={t('global.empty_results')} />;

  return (
    <PieChart
      title={t('stats.bookings_type_distribution') || 'Bookings type %'}
      labels={labels}
      data={values}
      backgroundColor={sliceColors}
    />
  );
}

export default BookingsTypeDistribution;
